<template>
  <v-container grid-list-sm>
    <v-layout>
      <v-flex xs12 md6 offset-sm3>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoReporte
            :titulo="titulo"
            :accion="accion"
            @ejecutarAccion="ejecutarAccion"
          />
          <v-card-text>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex xs12 md8>
                  <v-radio-group
                    v-model="itemActivo.FiltroPuntoVenta"
                    :mandatory="false"
                  >
                    <v-radio label="Todo" value="Todo"></v-radio>
                    <v-radio label="Un Punto de Venta" value="Uno"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex v-if="itemActivo.FiltroPuntoVenta == 'Uno'" xs12 md8>
                  <SelectPuntoVenta
                    :model="itemActivo.Id_PuntoVenta"
                    :rules="[rules.requerido]"
                    @seleccionarItem="seleccionarPuntoVenta"
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex md8>
                  <FechaRango
                    :fechaDesde="itemActivo.FechaDesde"
                    :fechaHasta="itemActivo.FechaHasta"
                    :rules="[rules.requerido]"
                    @seleccionarItem="seleccionarFecha"
                  />
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import EncabezadoReporte from "@/components/EncabezadoReporte";
import PieCrud from "@/components/PieCrud";
import Mensaje from "@/components/Mensaje";
import SelectPuntoVenta from "@/components/Sistema/SelectPuntoVenta";
import FechaRango from "@/components/FechaRango";
export default {
  name: "CajaListarSaldos",
  components: {
    EncabezadoReporte,
    PieCrud,
    Mensaje,
    SelectPuntoVenta,
    FechaRango
  },
  data() {
    return {
      titulo: "Saldos de Caja",
      rutaApi: "Caja/",
      itemVacio: {
        FiltroPuntoVenta: "Todo",
        NombrePuntoVenta: "",
        Id_PuntoVenta: 0,
        FechaDesde: "",
        FechaHasta: ""
      },
      itemActivo: {},
      rules: {
        requerido: v => !!v || "Requerido"
      },
      loading: false,
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      accion: ""
    };
  },
  created() {
    this.inicializar();
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Imprimir":
        case "ExportarXls":
          if (this.$refs.form.validate()) this.imprimir();
          break;
        case "CancelarError":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "Inicializar":
          this.$refs.form.resetValidation();
          this.inicializar();
          break;
      }
    },
    inicializar() {
      this.itemActivo = Object.assign({}, this.itemVacio);
    },
    seleccionarPuntoVenta(item) {
      this.itemActivo.Id_PuntoVenta = item.Id_PuntoVenta;
      this.itemActivo.NombrePuntoVenta = item.Nombre;
    },
    seleccionarFecha(item) {
      this.itemActivo.FechaDesde = item.FechaDesde;
      this.itemActivo.FechaHasta = item.FechaHasta;
    },
    imprimir() {
      this.loading = true;
      HttpHelper.getBlob(this.rutaApi + "ListarSaldos", {
        accion: this.accion,
        filtroPuntoVenta:
          this.itemActivo.FiltroPuntoVenta == "Todo"
            ? this.itemActivo.FiltroPuntoVenta
            : this.itemActivo.NombrePuntoVenta,
        id_PuntoVenta:
          this.itemActivo.FiltroPuntoVenta == "Todo"
            ? 0
            : this.itemActivo.Id_PuntoVenta,
        fechaDesde: this.itemActivo.FechaDesde,
        fechaHasta: this.itemActivo.FechaHasta
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          let fileName = response.headers["content-disposition"]
            .split(";")[1]
            .split("=")[1]
            .trim();
          link.setAttribute("download", "Reporte_" + fileName);
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    mostrarError(error) {
      var detalle;
      detalle =
        error.response == undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
